export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    PATCH = 'PATCH'
}

interface FetchRestProps {
    url: string;
    body?: any;
    method?: HttpMethod;
    headers?: Record<string, string>;
}



export async function fetchRest({ url, body, method = HttpMethod.GET, headers = {} }: FetchRestProps) {
    const token = sessionStorage.getItem('state');
    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                ...headers,
                ...token && {
                    Authorization: token,
                }
            },
            body: method !== 'GET' && body ? JSON.stringify(body) : undefined
        });
        const jsonResponse = await response.json();
        if (!response.ok) {
            throw new Error(jsonResponse.errors.map((err: any) => err.message).join(', '));
        }

        return jsonResponse;
    } catch (error) {
        return { error };
    }
}